export enum ETabType {
  DOCUMENTS = 'DOCUMENTS',
  COMPATIBLE_PRODUCTS = 'COMPATIBLE_PRODUCTS',
  SPECIFICATIONS = 'SPECIFICATIONS',
  EPDS = 'EPDS',
  DDC_DOCUMENTS = 'DDC_DOCUMENTS',
  DDC_SOFTWARE = 'DDC_SOFTWARE',
  SOFTWARE_CAROUSEL = 'SOFTWARE_CAROUSEL',
  LIFECYCLE_CAROUSEL = 'LIFECYCLE_CAROUSEL',
  EXPLORE_CAROUSEL = 'EXPLORE_CAROUSEL',
  FREQUENTLY_BOUGHT_CAROUSEL = 'FREQUENTLY_BOUGHT_CAROUSEL',
  FAQ = 'FAQ',
  REVIEWS = 'REVIEWS',
  ECOSTRUXURE = 'ECOSTRUXURE',
  SUSTAINABILITY = 'SUSTAINABILITY',
  ENVIRONMENTALDATA = 'ENVIRONMENTALDATA',
}

export const TABS_ORDER = [
  ETabType.DOCUMENTS,
  ETabType.COMPATIBLE_PRODUCTS,
  ETabType.SOFTWARE_CAROUSEL,
  ETabType.LIFECYCLE_CAROUSEL,
  ETabType.SPECIFICATIONS,
  ETabType.SUSTAINABILITY,
  ETabType.ENVIRONMENTALDATA,
  ETabType.EPDS,
  ETabType.DDC_DOCUMENTS,
  ETabType.DDC_SOFTWARE,
  ETabType.EXPLORE_CAROUSEL,
  ETabType.FREQUENTLY_BOUGHT_CAROUSEL,
  ETabType.FAQ,
  ETabType.REVIEWS,
];

export type TTabInfo = {
  type: ETabType;
  title: string;
};
